<template>
	<div class="viewpage" :cur-view="curView">
		<component :is="curView" :key="curView" />
	</div>
</template>

<script>
import Conversation from '../views/Conversation.vue';

import { mapGetters } from 'vuex';

export default {
	name: 'Viewpage',
	components: {
		Conversation
	},
	computed: {
		...mapGetters(['curView'])
	}
};
</script>
